import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import { Button, Input, Alert } from '../../components/common';
import './ProfilePage.css';

const ChangePasswordPage = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setMessage({ type: '', text: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.oldPassword || !formData.newPassword || !formData.confirmPassword) {
      setMessage({ type: 'error', text: '请填写所有字段' });
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setMessage({ type: 'error', text: '两次输入的新密码不一致' });
      return;
    }

    if (formData.newPassword.length < 8) {
      setMessage({ type: 'error', text: '新密码长度至少8位' });
      return;
    }

    setLoading(true);
    try {
      await authAPI.changePassword(
        formData.oldPassword,
        formData.newPassword,
        formData.confirmPassword
      );
      setMessage({ type: 'success', text: '密码修改成功，即将退出登录...' });
      
      // 3秒后退出登录
      setTimeout(async () => {
        await logout();
        navigate('/login');
      }, 3000);
    } catch (err) {
      const errorMsg = err.response?.data?.old_password?.[0] ||
        err.response?.data?.new_password?.[0] ||
        err.response?.data?.detail ||
        '密码修改失败，请稍后重试';
      setMessage({ type: 'error', text: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="profile-page">
      <div className="page-header">
        <h1>修改密码</h1>
        <p>定期更换密码可以提高账号安全性</p>
      </div>

      <div className="profile-content">
        <div className="profile-main" style={{ maxWidth: '560px' }}>
          <div className="profile-card">
            <h3 className="card-title">设置新密码</h3>

            {message.text && (
              <Alert
                type={message.type}
                message={message.text}
                onClose={() => setMessage({ type: '', text: '' })}
              />
            )}

            <form className="profile-form" onSubmit={handleSubmit}>
              <Input
                name="oldPassword"
                type="password"
                label="当前密码"
                placeholder="请输入当前密码"
                value={formData.oldPassword}
                onChange={handleChange}
                icon={
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                }
              />

              <Input
                name="newPassword"
                type="password"
                label="新密码"
                placeholder="请输入新密码（至少8位）"
                value={formData.newPassword}
                onChange={handleChange}
                icon={
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                }
              />

              <Input
                name="confirmPassword"
                type="password"
                label="确认新密码"
                placeholder="请再次输入新密码"
                value={formData.confirmPassword}
                onChange={handleChange}
                icon={
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                }
              />

              <div className="password-tips">
                <h4>密码要求：</h4>
                <ul>
                  <li>至少8个字符</li>
                  <li>建议包含大小写字母和数字</li>
                  <li>不能与用户名相似</li>
                </ul>
              </div>

              <div className="form-actions">
                <Button type="button" variant="secondary" onClick={() => navigate(-1)}>
                  取消
                </Button>
                <Button type="submit" loading={loading}>
                  确认修改
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordPage;

